import React, { useState, useEffect } from "react";
import api from "../../../services/axiosInstance";
import * as FaIcons from "react-icons/fa"; 
import CourseDetailsCard from "../../../pages/Prof/CourseDetailsCard";
import AllCategories from "../../../pages/AllCategories";
import Modal from "../../modals/Modal";
import CategoryCoursesModal from "../../../pages/CategoryCoursesModal";
 import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCertificate,
  faArrowRight,
  faFire,
  faChartLine,
  faRocket,
  faUserGraduate,
} from "@fortawesome/free-solid-svg-icons";
import {
  faHeart as faHeartRegular,
  faBookmark as faBookmarkRegular,
} from "@fortawesome/free-regular-svg-icons";
import {
  faHeart as faHeartSolid,
  faBookmark as faBookmarkSolid,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import RateProfessorModal from "../../modals/RateProfessorModal";
const Courses = () => {
  // detect if icon is an image
const isImageIcon = (icon) => {
  if (!icon) return false;
  return (true
  );
};

// get react-icon component dynamically
const getIconComponent = (iconName) => {
  if (!iconName) return null;
  return FaIcons[iconName] || null;
};

  const [profRatingModal, setProfRatingModal] = useState({
  isOpen: false,
  profId: null,
  onSubmitted: null,
});
const [profRatings, setProfRatings] = useState({}); // store ratings by profId

// Fetch professor rating helper
const fetchProfRating = async (profId) => {
  try {
    const { data } = await api.get(`/users/${profId}`);
    if (data.success) {
      setProfRatings((prev) => ({ ...prev, [profId]: data.data }));
    }
  } catch (err) {
    console.error("Error fetching prof rating", err);
  } 
};
  const navigate = useNavigate();
// Add this after your helper functions, before the return statement
const levelData = {
  Beginner: {
    color: "from-emerald-400 to-cyan-500",
    bg: "bg-gradient-to-br from-emerald-50 to-cyan-50",
    icon: faRocket,
    text: "text-emerald-700",
    badge: "bg-emerald-100 text-emerald-800",
  },
  Intermediate: {
    color: "from-blue-500 to-indigo-600",
    bg: "bg-gradient-to-br from-blue-50 to-indigo-50",
    icon: faChartLine,
    text: "text-blue-700",
    badge: "bg-blue-100 text-blue-800",
  },
  Advanced: {
    color: "from-violet-500 to-purple-600",
    bg: "bg-gradient-to-br from-violet-50 to-purple-50",
    icon: faFire,
    text: "text-purple-700",
    badge: "bg-purple-100 text-purple-800",
  },
};
  const [activeModal, setActiveModal] = useState({
    type: null,
    data: null
  });
  const [likedCourses, setLikedCourses] = useState({});
  const [savedCourses, setSavedCourses] = useState({});
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  


  // Fetch latest courses + user preferences
  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await api.get("/courses/latest");

        const sorted = [...data].sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        );

        const latestThree = sorted.slice(0, 3);
        const transformedCourses = latestThree.map((course) => ({
          id: course.id,
          title: course.name || "Cours sans nom",
          description: course.description || "Aucune description fournie",
          fullDescription: course.learn || "Ce que vous apprendrez dans ce cours",
          price: course.price ? `${course.price} DA` : "Gratuit",
          gradient: getRandomGradient(),
          icon: course.icon,
          niveau: course.niveau ? `Niveau: ${course.niveau}` : "Niveau non spécifié",
          instructor: {
            id:course.prof_id,
            name: course.instructor_name || "Instructeur inconnu",
            gradient: getInstructorGradient(),
            email: course.instructor_email,
            phone: course.instructor_phone,
            wilaya: course.instructor_wilaya,
            bio: course.instructor_bio,
            achievements: course.instructor_achievements,
          },
          learn: course.learn,
          prerequis: course.prerequis,
          duree: course.duree,
          certificat: course.certificat,
          programme: course.programme || [],
        }));

        setCourses(transformedCourses);
        await fetchUserPreferences();
      } catch (error) {
        console.error("Error fetching courses:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);
// Fetch professor ratings for all courses
useEffect(() => {
  if (courses.length === 0) return;

  const fetchAllProfRatings = async () => {
    try {
      // Get unique professor IDs from courses
      const profIds = [...new Set(courses.map(course => course.instructor.id))];
      
      // Fetch ratings for each professor in parallel
      const ratingPromises = profIds.map(async (profId) => {
        try {
          const { data } = await api.get(`/users/${profId}`);
          if (data.success) {
            return { profId, ratingData: data.data };
          }
        } catch (err) {
          console.error(`Error fetching rating for professor ${profId}:`, err);
        }
        return null;
      });

      const results = await Promise.all(ratingPromises);
      
      // Update state with all fetched ratings
      results.forEach(result => {
        if (result) {
          setProfRatings(prev => ({ 
            ...prev, 
            [result.profId]: result.ratingData 
          }));
        }
      });
    } catch (error) {
      console.error("Error fetching professor ratings:", error);
    }
  };

  fetchAllProfRatings();
}, [courses]); // Run when courses change

  // Fetch liked and saved courses
  const fetchUserPreferences = async () => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) return;

      const { data } = await api.get("/users/preferences", {
        headers: { Authorization: `Bearer ${token}` },
      });
      
      const likedMap = data.likedCourses || {};
      const savedMap = data.savedCourses || {};

      setLikedCourses(likedMap);
      setSavedCourses(savedMap);
    } catch (error) {
      console.error("Error fetching preferences:", error);
    }
  };

  // Helper functions
  const getRandomGradient = () => {
    const gradients = [
      "from-blue-600 to-blue-800",
      "from-red-600 to-red-800",
      "from-green-600 to-teal-600",
      "from-purple-600 to-purple-800",
      "from-orange-600 to-orange-800",
      "from-indigo-600 to-indigo-800",
    ];
    return gradients[Math.floor(Math.random() * gradients.length)];
  };

  const getInstructorGradient = () => {
    const gradients = [
      "from-blue-500 to-purple-600",
      "from-red-500 to-pink-600",
      "from-green-500 to-teal-600",
      "from-purple-500 to-pink-600",
      "from-orange-500 to-red-600",
      "from-indigo-500 to-purple-600",
    ];
    return gradients[Math.floor(Math.random() * gradients.length)];
  };


  // Toggle like
  const toggleLike = async (courseId) => {
    const newLikedState = !likedCourses[courseId];
    const token = localStorage.getItem("accessToken");

    if (!token) {
      alert("Veuillez vous connecter pour aimer ce cours");
      return;
    }

    try {
      await api.post(
        "/courses/like",
        { courseId, liked: newLikedState },
        { headers: { Authorization: `Bearer ${token}` }, withCredentials: true }
      );

      setLikedCourses((prev) => ({ ...prev, [courseId]: newLikedState }));
    } catch (error) {
      console.error("Error liking course:", error);
      alert("Erreur lors de la mise à jour du like");
    }
  };

  // Toggle save
  const toggleSave = async (courseId) => {
    const newSavedState = !savedCourses[courseId];
    const token = localStorage.getItem("accessToken");

    if (!token) {
      alert("Veuillez vous connecter pour sauvegarder ce cours");
      return;
    }

    try {
      await api.post(
        "/courses/save",
        { courseId, saved: newSavedState },
        { headers: { Authorization: `Bearer ${token}` }, withCredentials: true }
      );

      setSavedCourses((prev) => ({ ...prev, [courseId]: newSavedState }));
    } catch (error) {
      console.error("Error saving course:", error);
      alert("Erreur lors de la mise à jour de la sauvegarde");
    }
  };

  const registerCourse = async (courseName, courseId) => {
    const token = localStorage.getItem("accessToken");
    if (!token) {
      alert("Connectez-vous d'abord !");
      return;
    } 
    
    const phoneNumber = "213549075577";
    const message = `Bonjour ! Je suis intéressé(e) par la formation "${courseName}". Pouvez-vous me donner plus d'informations ?`;
    
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappURL, "_blank");

  }; 

  const registerCourse2 = async (courseName, courseId) => {
   
    const phoneNumber = "213549075577";
    const message = `Bonjour ! Je suis intéressé(e) par la formation "${courseName}". Pouvez-vous me donner plus d'informations ?`;
    
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappURL, "_blank");

  }; 

  const registerCourseNoSubscription = async (courseName, courseId) => {
    const phoneNumber = "213549075577";
    const message = `Bonjour ! Je suis intéressé(e) par la formation "${courseName}". Pouvez-vous me donner plus d'informations ?`;
    
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappURL, "_blank");
  }; 
const forceCloseAll = () => {
    setActiveModal({ type: null, data: null });
};
  const closeModal = () => {
  if (activeModal.type === "course-details") {
    // Go back to category courses
    setActiveModal({
      type: "category-courses",
      data: { category: activeModal.data.category }
    });
  } else if (activeModal.type === "category-courses") {
    // Go back to all categories
    setActiveModal({ type: "categories", data: null });
  } else {
    // Default: close everything
    setActiveModal({ type: null, data: null });
  }
};  

  const openModal = (type, data = null) => {
    setActiveModal({ type, data });
  };

  if (loading)
    return (
      <section className="py-20 bg-gray-50 text-center">
        <div className="animate-pulse text-gray-500">Chargement des formations...</div>
      </section>
    );

  return ( 
    <section id="formations" className="pt-12 bg-gray-50">
      <section className="relative max-w-7xl mx-auto px-4 overflow-hidden">
  {/* Animated background elements */}
  <div className="absolute top-0 left-0 w-96 h-96 bg-gradient-to-br from-indigo-100/30 to-purple-100/20 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" />
  <div className="absolute bottom-0 right-0 w-96 h-96 bg-gradient-to-tr from-cyan-100/20 to-blue-100/30 rounded-full blur-3xl translate-x-1/3 translate-y-1/3" />

  {/* Title with enhanced styling - Keeping your original text */}
 <motion.div
  initial={{ opacity: 0, y: 30 }}
  whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true }}
  transition={{ duration: 0.5 }}
  className="text-center mb-12 md:mb-16"
>
  {/* Elegant minimalist title */}
  <div className="relative mb-6">
  <div className="text-center">
    <h1 className="text-4xl font-bold text-gray-900 mb-3">
      Nos Formations
    </h1>
    <p className="text-gray-600 max-w-2xl mx-auto">
      Développez vos compétences avec nos programmes spécialisés
    </p>
  </div>
</div>

</motion.div>

  {/* Grid with enhanced layout - Applying the design to your courses */}
  <div className="grid  grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 relative">
    {courses.map((course, index) => {
      const niveauText = course.niveau.replace("Niveau: ", "").trim();
const level = levelData[niveauText] || levelData["Beginner"];
      
      return (
        <motion.div
          key={course.id}
          initial={{ opacity: 0, y: 60, scale: 0.95 }}
          whileInView={{ opacity: 1, y: 0, scale: 1 }}
          viewport={{ once: true }}
          transition={{ 
            delay: index * 0.15,
            type: "spring",
            stiffness: 100,
            damping: 15
          }}
          whileHover={{ 
            y: -12,
            transition: { type: "spring", stiffness: 300 }
          }}
          className="group relative h-full flex"
        >
          {/* Card container with gradient border */}
          <div className={`relative flex flex-col h-full w-full rounded-2xl ${level.bg} p-0.5`}>
            <div className="relative flex flex-col h-full bg-white rounded-[1.2rem] overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300">
              {/* Corner accent */}
              <div className={`absolute top-0 right-0 w-20 h-20 bg-gradient-to-bl ${level.color} opacity-10 rounded-bl-full pointer-events-none`} />

              {/* Header with level indicator */}
              <div className="relative px-5 pt-5">
                <div className="flex items-start justify-between mb-4">
                  <div className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full ${level.badge} backdrop-blur-sm border border-white/50`}>
                    <FontAwesomeIcon icon={level.icon} className="text-xs" />
                    <span className="text-xs font-semibold">{course.niveau}</span>
                  </div>
                  
                  <div className="flex items-center gap-2">
                    <motion.button
  whileTap={{ scale: 0.9 }}
  onClick={() => toggleLike(course.id)}
  className={`w-8 h-8 rounded-lg flex items-center justify-center backdrop-blur-sm ${
    likedCourses[course.id] 
      ? 'bg-red-50 border border-red-100' 
      : 'bg-white/80 border border-gray-100'
  }`}
>
  {likedCourses[course.id] ? (
    <FaIcons.FaHeart className="text-red-500 scale-110" />
  ) : (
    <FaIcons.FaRegHeart className="text-gray-400 hover:text-red-500" />
  )}
</motion.button>

<motion.button
  whileTap={{ scale: 0.9 }}
  onClick={() => toggleSave(course.id)}
  className={`w-8 h-8 rounded-lg flex items-center justify-center backdrop-blur-sm ${
    savedCourses[course.id] 
      ? 'bg-indigo-50 border border-indigo-100' 
      : 'bg-white/80 border border-gray-100'
  }`}
>
  {savedCourses[course.id] ? (
    <FaIcons.FaBookmark className="text-emerald-600 scale-110" />
  ) : (
    <FaIcons.FaRegBookmark className="text-gray-400 hover:text-emerald-600" />
  )}
</motion.button>
 
                  </div>
                </div>

                {/* Course icon with floating effect */}
     <motion.div 
  whileHover={{ scale: 1.05 }}
  className={`relative w-14 h-14 rounded-xl mb-4 overflow-hidden bg-gradient-to-br ${level.color} p-0.5 flex items-center justify-center`}
>
  <div className="w-full h-full bg-white rounded-xl flex items-center justify-center overflow-hidden">

    {/* IMAGE ICON */}
   {isImageIcon(course.icon) && (
                  <img
                    src={
                      course.icon.startsWith("http") || course.icon.startsWith("https")
                        ? course.icon
                        : `${process.env.REACT_APP_LOCAL_API_URL}${course.icon}`
                    }
                    alt="course icon"
                    className="w-8 h-8 object-contain"
                  />
                )}

    {/* REACT ICON */}
   {!isImageIcon(course.icon) && getIconComponent(course.icon) && (
                     <div
                       className={`text-2xl bg-gradient-to-br ${level.color} bg-clip-text `}
                     >
                       {React.createElement(getIconComponent(course.icon))}
                     </div>
                   )}

    {/* FALLBACK */}
    {!course.icon && (
      <div
        className={`text-xl font-bold bg-gradient-to-br ${level.color} bg-clip-text text-transparent`}
      >
        {course.title.charAt(0)}
      </div>
    )}

  </div>
</motion.div>
 {/* Course title with gradient */}
                <h3 className="text-lg font-bold text-gray-900 mb-2 leading-tight line-clamp-2">
                  {course.title}
                </h3>

                {/* Course description */}
                <p className="text-sm text-gray-600 mb-4 leading-relaxed line-clamp-2">
                  {course.description}
                </p>
              </div>

              {/* Flexible spacer */}
              <div className="flex-grow"></div>

              {/* Instructor section */}
              <div className="px-5 mb-4">
                <div className="flex items-center gap-2 p-3 rounded-xl backdrop-blur-sm border border-gray-100">
                  <div className={`w-8 h-8 rounded-lg bg-gradient-to-br backdrop-blur-sm flex items-center justify-center shrink-0`}>
                    <FontAwesomeIcon icon={faUserGraduate} className="text-gray-600 text-xs" />
                  </div>
                  <div className="min-w-0">
                    <p className="text-xs text-gray-500">Instructor</p>
                    <p className="font-semibold text-gray-900 text-sm truncate">{course.instructor.name}</p>
                  </div>
                </div>
              </div>

              {/* Footer with buttons */}
              <div className="px-5 pb-4 pt-3 border-t border-gray-100 bg-white">
                <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
                  <div className="w-full sm:w-auto">
                    <p className="text-xs text-gray-500 mb-0.5">Prix</p>
                    <div className="flex items-baseline gap-1">
                      <span className="text-xl font-bold text-gray-900">{course.price}</span>
                    </div>
                  </div>
                  
                  <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
                    <motion.button
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                      onClick={() => navigate(`/courses/${course.id}`)}
                      className="px-4 py-2.5 rounded-lg border border-gray-200 text-xs font-semibold text-gray-700 hover:border-gray-300 hover:bg-gray-50 transition-all flex items-center justify-center gap-1.5 w-full sm:w-auto"
                    > Voir détails
                      <FontAwesomeIcon icon={faArrowRight} className="text-[10px]" />
                    </motion.button>
                    
                    <motion.button
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                      onClick={() => registerCourse(course.title, course.id)}
                      className={`px-4 py-2.5 rounded-lg bg-emerald-400 text-white text-xs font-semibold hover:shadow-lg transition-all shadow-sm hover:shadow-indigo-200 flex items-center justify-center gap-1.5 w-full sm:w-auto`}
                    >
                      <FontAwesomeIcon icon={faUserGraduate} className="text-[10px]" />
                      S'inscrire
                      <FontAwesomeIcon icon={faArrowRight} className="text-[10px]" />
                    </motion.button>
                  </div>
                </div>
              </div>
{/* Instructor section with rating */}
<div className="px-5 mb-4">
  <div className="flex items-center gap-2 p-3 rounded-xl backdrop-blur-sm border border-gray-100 justify-between">
    <div className="flex items-center gap-2">
      <div className={`w-8 h-8 rounded-lg bg-gradient-to-br flex items-center justify-center shrink-0`}>
        <FontAwesomeIcon icon={faUserGraduate} className="text-gray-600 text-xs" />
      </div>
      <div className="min-w-0">
        <p className="text-xs text-gray-500">Instructor</p>
        <p className="font-semibold text-gray-900 text-sm truncate">{course.instructor.name}</p>
      </div>
    </div>

    {/* Display rating */}
    <div className="flex items-center gap-1">
      {Array.from({ length: 5 }, (_, i) => (
        <FaIcons.FaStar
          key={i}
          size={14}
          className={`${
            i < (profRatings[course.instructor.id]?.average_rating || 0)
              ? "text-yellow-400"
              : "text-gray-300"
          }`}
        />
      ))}
      <span className="text-xs text-gray-500 ml-1">
        ({profRatings[course.instructor.id]?.total_ratings || 0})
      </span>
    </div>

    {/* Rate button */}
    <button
      onClick={() =>
        setProfRatingModal({
          isOpen: true,
          profId: course.instructor.id,
          onSubmitted: () => fetchProfRating(course.instructor.id),
        })
      }
      className="ml-2 text-xs text-blue-600 hover:underline"
    >
      Rate
    </button>
  </div>
</div>

              {/* Hover shine effect */}
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000 pointer-events-none" />
            </div>
          </div>
        </motion.div>
      );
    })}
  </div>

  {/* Floating CTA - Using your original button but with enhanced styling */}
<motion.div className="mt-20 text-center">
  <motion.button
    type="button"
    onClick={() => navigate("/all-courses")}
    whileTap={{ scale: 0.95 }}
    className="
      inline-flex items-center gap-3
      px-6 py-4
      text-[#2fb383] font-bold text-lg
      hover:text-[#269c6f]
      transition-colors
      touch-manipulation
      relative z-10
    "
  >
    Plus de formations
    <FontAwesomeIcon
      icon={faArrowRight}
      className="text-sm pointer-events-none"
    />
  </motion.button>
</motion.div>

</section>

      {/* UNIVERSAL MODAL HANDLER */}
      {/* {activeModal.type === "categories" && (
  <Modal onClose={forceCloseAll}>
    <AllCategories onSelectCategory={(cat) => openModal("category-courses", { category: cat })} />
  </Modal> 
)} */}

{activeModal.type === "category-courses" && (
  <Modal onClose={forceCloseAll}>
    <CategoryCoursesModal
      category={activeModal.data.category}
      onClose={closeModal}
      onSelectCourse={(course) =>
        openModal("course-details", {
          course,
          category: activeModal.data.category
        })
      }
    />
  </Modal>
)}

{activeModal.type === "course-details" && (
  <Modal onClose={forceCloseAll}>
    <CourseDetailsCard
      registerCourse={registerCourse2}
      registerCourseNoSubscripption={registerCourseNoSubscription}
      course={activeModal.data.course || activeModal.data}
      onBack={closeModal}
    />
  </Modal>
)}
{profRatingModal.isOpen && (
  <RateProfessorModal
    profId={profRatingModal.profId}
    onClose={() => setProfRatingModal({ isOpen: false, profId: null, onSubmitted: null })}
    onSubmitted={() => {
      profRatingModal.onSubmitted?.();
      setProfRatingModal({ isOpen: false, profId: null, onSubmitted: null });
    }}
  />
)}

 
    </section>
  );
};

export default Courses; 